import React from 'react'
import Kesehatan from '../../component/cek-kesehatan/Kesehatan'

function CheckKesehatan() {
    return (
        <Kesehatan />
    )
}

export default CheckKesehatan